import React from 'react';
import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { useInsuredData } from '../../../../services/insured-service';

import RecordsBody from './RecordsBody';
import RecordsHeader from './RecordsHeader';

const Records = ({ insuredId, recordId }) => {
  const { data: insuredData } = useInsuredData(insuredId);

  if (insuredData?.deletedAt) {
    return null;
  }

  return (
    <Box
      layerStyle="accordion"
      mb={8}
    >
      <RecordsHeader insuredId={insuredId} />
      <RecordsBody insuredId={insuredId} recordId={recordId} />
    </Box>
  );
};

Records.propTypes = {
  insuredId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  recordId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default Records;
